package com.merkost.handpass.admin.contract

import com.merkost.handpass.api.dto.admin.AdminConversationMessage
import com.merkost.handpass.api.dto.admin.AdminConversationSummary
import com.merkost.handpass.api.dto.admin.AdminListingDetail
import com.merkost.handpass.api.dto.admin.AdminNote
import com.merkost.handpass.api.dto.admin.AuditEntry
import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

sealed interface ListingDetailState : MVIState {
    data object Loading : ListingDetailState
    data class Content(
        val detail: AdminListingDetail,
        val activeTab: ListingDetailTab = ListingDetailTab.Overview,
        val notes: AsyncSection<List<AdminNote>> = AsyncSection.Loading,
        val audit: AsyncSection<List<AuditEntry>> = AsyncSection.Loading,
        val newNoteDraft: String = "",
        val conversations: AsyncSection<List<AdminConversationSummary>> = AsyncSection.Loading,
        val conversationsRequested: Boolean = false,
        val openConversation: AdminConversationSummary? = null,
        val messages: AsyncSection<List<AdminConversationMessage>> = AsyncSection.Loading,
    ) : ListingDetailState
    data class Error(val message: String) : ListingDetailState
}

enum class ListingDetailTab { Overview, Notes, Conversations, ViewedBy }

sealed interface ListingDetailIntent : MVIIntent {
    data class Init(val listingId: String) : ListingDetailIntent
    data class SetTab(val tab: ListingDetailTab) : ListingDetailIntent
    data object TapSuspend : ListingDetailIntent
    data object TapRestore : ListingDetailIntent
    data class ConfirmAction(val kind: ListingDetailActionKind, val reason: String?) : ListingDetailIntent
    data class UndoRestore(val listingId: String) : ListingDetailIntent
    data object Refresh : ListingDetailIntent
    data class SetNoteDraft(val body: String) : ListingDetailIntent
    data object SubmitNote : ListingDetailIntent
    data class DeleteNote(val noteId: String) : ListingDetailIntent
    data object LoadConversations : ListingDetailIntent
    data class OpenConversation(val conversation: AdminConversationSummary) : ListingDetailIntent
    data object CloseConversation : ListingDetailIntent
}

enum class ListingDetailActionKind { Suspend, Restore }

sealed interface ListingDetailAction : MVIAction {
    data class OpenReasonModal(val kind: ListingDetailActionKind, val targetTitle: String) : ListingDetailAction
    data class Navigate(val path: String) : ListingDetailAction
    data class ShowSuccess(val message: String) : ListingDetailAction
    data class ShowUndoableSuccess(val message: String, val listingId: String) : ListingDetailAction
    data class ShowError(val message: String) : ListingDetailAction
}
